var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suspension",style:({ right: _vm.right, bottom: _vm.bottom }),on:{"click":_vm.share}},[(!Object.is(_vm.img, 'false'))?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_c('span',{staticClass:"desc",style:({ 'padding': Object.is(_vm.img, 'false') ? '8px' : 0 })},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }